import { Chip } from '@mui/material';
import { ModuleChange, ModuleChangeChangeTypeEnum } from '../../../API';
import { Box } from '@mui/material';
import React from 'react';
import { changeMovedAndModified } from './utils';

export function ChangeBadges({ change }: { change: ModuleChange }): React.ReactElement {
  const badges: React.ReactNode[] = [];
  const wasMovedAndModified = changeMovedAndModified(change);

  // Add ADDED badge first (treated as NEW)
  if (change.changeType === ModuleChangeChangeTypeEnum.ADDED) {
    badges.push(
      <Chip
        key="added"
        label="new"
        size="small"
        sx={{
          bgcolor: getChangeColor(ModuleChangeChangeTypeEnum.ADDED),
          color: 'white',
          fontSize: '0.7rem',
          height: 20
        }}
      />
    );
  }

  // Add MOVED badge second
  if (change.changeType === ModuleChangeChangeTypeEnum.MOVED || wasMovedAndModified) {
    badges.push(
      <Chip
        key="moved"
        label="moved"
        size="small"
        sx={{
          bgcolor: 'info.main',
          color: 'white',
          fontSize: '0.7rem',
          height: 20
        }}
      />
    );
  }

  // Add MODIFIED badge third
  if (change.changeType === ModuleChangeChangeTypeEnum.MODIFIED) {
    badges.push(
      <Chip
        key="modified"
        label="modified"
        size="small"
        sx={{
          bgcolor: getChangeColor(ModuleChangeChangeTypeEnum.MODIFIED),
          color: 'white',
          fontSize: '0.7rem',
          height: 20
        }}
      />
    );
  }

  // Add REMOVED badge if needed
  if (change.changeType === ModuleChangeChangeTypeEnum.REMOVED) {
    badges.push(
      <Chip
        key="removed"
        label="removed"
        size="small"
        sx={{
          bgcolor: getChangeColor(ModuleChangeChangeTypeEnum.REMOVED),
          color: 'white',
          fontSize: '0.7rem',
          height: 20
        }}
      />
    );
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {badges}
    </Box>
  );
}

const getChangeColor = (changeType: ModuleChangeChangeTypeEnum) => {
  switch (changeType) {
    case ModuleChangeChangeTypeEnum.ADDED:
      return 'success.main';
    case ModuleChangeChangeTypeEnum.REMOVED:
      return 'error.main';
    case ModuleChangeChangeTypeEnum.MOVED:
      return 'info.main';
    case ModuleChangeChangeTypeEnum.MODIFIED:
      return 'warning.main';
    default:
      return 'text.primary';
  }
};
